(() => {
  const predictiveSearch = document.querySelector('predictive-search');
  if (!predictiveSearch || customElements.get('predictive-search')) return;

  const source =
    document.currentScript?.src ||
    Array.from(document.scripts)
      .map((script) => script.src)
      .find((src) => src.includes('/predictive-search.js'));

  if (!source) return;

  const coreUrl = source.replace(/predictive-search\.js(?=\?|$)/, 'predictive-search-core.js');
  let loadPromise;

  const removeIntentListeners = () => {
    document.removeEventListener('pointerover', onSearchIntent, true);
    document.removeEventListener('pointerdown', onSearchIntent, true);
    document.removeEventListener('focusin', onSearchIntent, true);
  };

  const refreshActiveSearch = () => {
    document.querySelectorAll('predictive-search').forEach((instance) => {
      const currentTerm = instance.input?.value.trim();
      if (currentTerm && currentTerm !== instance.searchTerm) instance.onChange();
    });
  };

  const loadCore = () => {
    if (customElements.get('predictive-search')) {
      removeIntentListeners();
      refreshActiveSearch();
      return Promise.resolve();
    }

    if (loadPromise) return loadPromise;

    loadPromise = new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.src = coreUrl;
      script.async = true;
      script.onload = () => {
        removeIntentListeners();
        customElements.whenDefined('predictive-search').then(refreshActiveSearch);
        resolve();
      };
      script.onerror = () => {
        loadPromise = null;
        reject(new Error('Unable to load predictive search.'));
      };
      document.head.appendChild(script);
    });

    return loadPromise;
  };

  function onSearchIntent(event) {
    const target = event.target;
    if (!(target instanceof Element)) return;
    if (!target.closest('details-modal.header__search, predictive-search')) return;

    loadCore().catch(() => {});
  }

  document.addEventListener('pointerover', onSearchIntent, { capture: true, passive: true });
  document.addEventListener('pointerdown', onSearchIntent, { capture: true, passive: true });
  document.addEventListener('focusin', onSearchIntent, true);

  if (document.querySelector('predictive-search input[type="search"]:focus')) {
    loadCore().catch(() => {});
  }
})();
